/* app/ui/video/video.load */

define(
	'app/ui/video/video.load',[
		'jquery',
		'util/mediaqueries',
		'magnificPopup'
	],
	function($, MediaQueries) {

		var Module;
		var $heroVideos;

		return {
			init: function() {
				Module = this;
				$heroVideos = $('.js-hero-video');

				if ($heroVideos.length) {
					Module._initMediaQueries();
				}
			},

			_initMediaQueries: function() {

				MediaQueries.register([
					{
						queries: MediaQueries.queries['megamenu--small'],
						shouldDegrade: false,
						match: Module._initMobilePopup
					},
					{
						queries: MediaQueries.queries['megamenu--large'],
						shouldDegrade: true,
						match: Module._loadVideo
					}
				]);
			},

			_loadVideo: function () {
				for (var i = 0; i < $heroVideos.length; i++) {
					var $vid = $heroVideos.eq(i);
					var $sources = $vid.find('source');

					for (var j = 0; j < $sources.length; j++) {
						var $source = $sources.eq(j);
						var src = $source.data('src');

						if (src !== '') {
							$source.attr('src', src);
						}
					}

					$vid[0].load();
					$vid[0].play();
				}
			},

			_initMobilePopup: function () {
				var $triggerBtn = $('.js-hero-video-play-mobile');
				if ($triggerBtn.length) {
					$triggerBtn.magnificPopup({
						type: 'inline',
						items: {
							src: $('.js-hero-video-mobile'),
						},
						callbacks: {
							open: function () {
								$('.js-hero-video-mobile').find('video')[0].play();
							},
							close: function () {
								$('.js-hero-video-mobile').find('video')[0].load();
							}
						}
					}).attr('data-mfp-src', '#js-hero-video-mobile');
				}
			}
		};
	}
);
